function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, String, email, emailError, fullName, loggedIn, nameError, nextUrl, stage) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['logged-in-message'] = function(email) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'logged-in-notice': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'icon': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "attrs": __vjadeStringifyAttrsIfObj({
                icon: `info`
              }),
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "attrs": __vjadeStringifyAttrsIfObj({
              class: `auth-form-field-content text`
            }),
            "class": {
              'div': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("You are logged in as");
            __jade_nodes = __jade_nodes.concat(h("b", [__vjadeSafeCode(` ${email}`)]));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['fields'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'auth-form-field-row': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-shadowless-input", {
            "attrs": __vjadeStringifyAttrsIfObj({
              'field-id': `id_fullName`,
              'field-name': `fullName`,
              label: `Full Name`,
              'validation-status': nameError,
              'error-message': `Full name is required`,
              disabled: `${loggedIn}`,
            }),
            "props": {
              value: fullName
            },
            "on": {
              keydown: $helpers.handleKeydown,
              input: $helpers.handleNameInput
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'auth-form-field-row': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-shadowless-input", {
            "attrs": __vjadeStringifyAttrsIfObj({
              'field-id': `id_email`,
              'field-name': `email`,
              label: `Email Address`,
              'validation-status': emailError,
              'error-message': `Email address is required. Please enter a valid email address`,
              disabled: `${loggedIn}`,
            }),
            "props": {
              value: email
            },
            "on": {
              keydown: $helpers.handleKeydown,
              input: $helpers.handleEmailInput,
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['login-or-switch-button'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'auth-form-field-row': true
          },
          "props": {
            id: 'last-row'
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("a", {
            "attrs": __vjadeStringifyAttrsIfObj({
              href: $helpers.getSecondaryButtonLink()
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-button", {
              "attrs": __vjadeStringifyAttrsIfObj({
                size: `large`,
                theme: `secondary`,
                href: $helpers.getSecondaryButtonLink()
              }),
              "class": {
                'auth-form-field-action-button': true
              },
            }, [__vjadeSafeCode(loggedIn ? `Switch Account` : `Log In`)]));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['custom-help-link-form'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("p", {
            "class": {
              'auth-form-description': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("It looks like you want to view a report, but either don't have access or aren't logged in.");;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(($attr(`help-message`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("p", {
              "class": {
                'auth-form-description': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat($attr(`help-message`));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'auth-form-field-row': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-button", {
              "attrs": __vjadeStringifyAttrsIfObj({
                size: `large`,
                theme: `primary`,
                href: $attr(`help-link`)
              }),
              "class": {
                'auth-form-field-action-button': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Access Instructions");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat((!loggedIn) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'secondary-action-divider': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("OR");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(jade_mixins['login-or-switch-button'].call(this));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['common-form'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((!loggedIn) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'auth-form-subtitle': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("It looks like you want to view a report, but either don't have access or aren't logged in.");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(jade_mixins['fields'].call(this));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'logged-in-message': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'auth-form-subtitle': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("It looks like you want to view a report, but don't have access or you");
                __jade_nodes = __jade_nodes.concat(" need to log into an account with permission.");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'auth-form-field-row': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(jade_mixins['logged-in-message'].call(this, email));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'auth-form-field-row': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-button", {
              "attrs": __vjadeStringifyAttrsIfObj({
                size: `large`,
                theme: `primary`
              }),
              "on": {
                click: $helpers.submitRequest
              },
              "class": {
                'auth-form-field-action-button': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Request Access");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'secondary-action-divider': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("OR");;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(jade_mixins['login-or-switch-button'].call(this));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("auth-container", {
        "attrs": __vjadeStringifyAttrsIfObj({
          'show-footer-links': true,
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "attrs": __vjadeStringifyAttrsIfObj({
            slot: `auth-form-slot`
          }),
          "class": {
            'auth-form': true,
            'request-form': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("form", {
            "attrs": __vjadeStringifyAttrsIfObj({
              id: `mpRequestAccess`,
              method: `post`,
              action: `/request_access/?next=${nextUrl}`
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "key": 'g-recapcha',
              "attrs": __vjadeStringifyAttrsIfObj({
                id: `recaptcha`,
                class: `g-recaptcha `,
                'data-size': `invisible`,
                'data-sitekey': $attr(`recaptcha-key`),
                'data-callback': `handleSuccessfulRecaptchaResponse`,
              }),
              "class": {
                'request-access-recaptcha': true
              },
            }));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "attrs": __vjadeStringifyAttrsIfObj({
                class: `error-band stage-${stage}`
              }),
              "class": {
                'div': true
              },
            }));
            __jade_nodes = __jade_nodes.concat((stage === `input`) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("h1", {
                "class": {
                  'auth-form-title': true
                },
              }, [__vjadeSafeCode(`You Need Permission`)]));
              __jade_nodes = __jade_nodes.concat(($attr(`help-link`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(jade_mixins['custom-help-link-form'].call(this));;
                return __jade_nodes
              }).call(this)) : ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(jade_mixins['common-form'].call(this));;
                return __jade_nodes
              }).call(this)));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat((stage === "already-invited") ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("h1", {
                "class": {
                  'auth-form-title': true
                },
              }, [__vjadeSafeCode(`Pending Invite`)]));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'auth-form-field-content': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Someone has already invited you to this project.  We have resent an invite email, please check your inbox to join");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat((stage === "sent") ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("h1", {
                "class": {
                  'auth-form-title': true
                },
              }, [__vjadeSafeCode(`Request Sent`)]));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'auth-form-field-content': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("p", (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("An email has been sent to the project owners notifying them about your request.");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("p", (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("You will receive an email when your request is approved.");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat((stage === "invite-invalid") ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("h1", {
                "class": {
                  'auth-form-title': true
                },
              }, [__vjadeSafeCode(`Invite Invalid`)]));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'auth-form-field-content': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("p", (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("span", (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("This invite might have been used, or the link is invalid. If you believe this is an error please contact our");
                    __jade_nodes = __jade_nodes.concat(" world class");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("a", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      href: 'https://help.mixpanel.com/hc/en-us/requests/new'
                    }),
                  }, [__vjadeSafeCode(" support team.")]));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("a", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  href: `/`
                }),
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    size: `large`,
                    theme: `primary`
                  }),
                  "class": {
                    'auth-form-field-action-button': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Continue To Mixpanel");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat((stage === "invite-expired") ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("h1", {
                "class": {
                  'auth-form-title': true
                },
              }, [__vjadeSafeCode(`Invite Expired`)]));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'auth-form-field-content': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("p", (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("span", (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("This invite has expired. Please check with the person who invited you");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(($attr('inviter-email')) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("a", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        href: `mailto:${$attr('inviter-email')}`
                      }),
                    }, [__vjadeSafeCode(` ${$attr("inviter-email")}`)]));;
                    return __jade_nodes
                  }).call(this)) : undefined);
                  __jade_nodes = __jade_nodes.concat(h("span", (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(" to ask for a new invitation.");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat((nextUrl !== ``) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'auth-form-field-row': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-button", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      size: `large`,
                      theme: `primary`
                    }),
                    "on": {
                      click: $helpers.expiredRequest
                    },
                    "class": {
                      'auth-form-field-action-button': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("Request New Invite");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("a", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    href: `/`
                  }),
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-button", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      size: `large`,
                      theme: `primary`
                    }),
                    "class": {
                      'auth-form-field-action-button': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("Continue To Mixpanel");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(($attr(`help-link`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'auth-form-footer': true,
                'contact-supports': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Having trouble logging in? ");
                __jade_nodes = __jade_nodes.concat((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("a", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      href: 'https://help.mixpanel.com/hc/en-us/requests/new',
                      class: `mp-link`
                    }),
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("Get help");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this));
                __jade_nodes = __jade_nodes.concat("");;
                return __jade_nodes
              }).call(this));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "email" in locals ? locals.email : typeof email !== "undefined" ? email : undefined, "emailError" in locals ? locals.emailError : typeof emailError !== "undefined" ? emailError : undefined, "fullName" in locals ? locals.fullName : typeof fullName !== "undefined" ? fullName : undefined, "loggedIn" in locals ? locals.loggedIn : typeof loggedIn !== "undefined" ? loggedIn : undefined, "nameError" in locals ? locals.nameError : typeof nameError !== "undefined" ? nameError : undefined, "nextUrl" in locals ? locals.nextUrl : typeof nextUrl !== "undefined" ? nextUrl : undefined, "stage" in locals ? locals.stage : typeof stage !== "undefined" ? stage : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;